import React, { useContext } from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import TypeStoreContext from 'context/TypeStoreContext';
import LinksDefault from './Interfaces/LinksDefault';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import { DataFormProps } from 'types/InputsRedirectableLinkProps';

interface RedirectableLinksProps {
	item: ItemDynamicPageInPhone;
}

//esse componente tem o mesmo layout em todos os tipos de loja, mas deixei essa função para demostrar como tem que ser a divisão por tipo (por que esse foi meu primeiro módulo que fiz o layout, depois posso apagar)
export default function RedirectableLinks({ item }: RedirectableLinksProps) {
	const { typeStore } = useContext(TypeStoreContext);

	const { data } = item;

	const links: DataFormProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <LinksDefault item={data} />;

			case 'grocery':
				return <LinksDefault item={data} />;

			case 'fashion':
				return <LinksDefault item={data} />;

			default:
				return <LinksDefault item={data} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(links?.schedule?.start !== '' || links?.schedule?.end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={links?.schedule?.countdown || false}
					endDate={links?.schedule?.end || ''}
					startDate={links?.schedule?.start || ''}
				/>
			)}
			{returnInterfaceByTypeStore()}
		</S.container>
	);
}
